import { render, staticRenderFns } from "./GroupChatList.vue?vue&type=template&id=79731333&"
import script from "./GroupChatList.vue?vue&type=script&lang=js&"
export * from "./GroupChatList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports